import React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { ViewPrivilegesWrapper } from "../../Components/ManageUsers/ManageUsers/ManageUsersStyled";
import { Box, Typography } from "@mui/material";
import { Constants } from "./Content";
import { TextareaAutosize } from '@mui/base/TextareaAutosize';

const ViewRecDialog = ({ title, quoteName, show, handleClose, data }) => {
  return (
    <div>
      <ViewPrivilegesWrapper
        open={show}
        onClose={handleClose}
        scroll="paper"
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title" className="customDialogTitle">
          {title}
        </DialogTitle>
        <DialogContent>
          <Box className="samRecBox">
            <DialogContentText
              id="alert-dialog-description"
              className="customDialog"
            >
             {/* <TextareaAutosize className="samRecTexaArea" minRows={20} maxRows={20}  defaultValue={data} disabled/> */}
             <Box className='samRecBoxData'>{data}</Box>
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions className="dialogbutton">
          <Button variant="contained" color="success" onClick={handleClose}>
            {Constants.OK}
          </Button>
        </DialogActions>
      </ViewPrivilegesWrapper>
    </div>
  );
};

export default ViewRecDialog;
